class Search {
    /**
     * @param root {Element|HTMLElement}
     */
    constructor(root, alwaysOpen = false) {
        this.root = root
        this.alwaysOpen = alwaysOpen

        this.initializeElements()
        this.initializeEvents()
    }

    initializeElements() {
        this.submit = this.root.querySelector('[data-component-part="submit"]')
        this.clear = this.root.querySelector('[data-component-part="clear"]')
        this.input = this.root.querySelector('input')

        this.autoCompleteUrl = this.root.dataset.autoCompleteUrl
    }

    initializeEvents() {
        this.submit.addEventListener('click', ev => {
            if (this.open()) {
                ev.preventDefault()
            }
        })

        this.clear.addEventListener('click', ev => {
            this.close()
        })

        this.root.addEventListener('click', ev => {
            // Avoid click bubble up
            ev.stopPropagation()
        })

        document.addEventListener('click', () => {
            this.close(true)
        })

    }

    open() {
        if (this.alwaysOpen) {
            return false
        }

        if (this.root.classList.contains('is-open')) {
            return false
        }

        this.root.classList.add('is-open')
        this.input.focus()

        return true
    }

    close(force = false) {
        if (this.input.value.trim() === '' || force) {
            this.root.classList.remove('is-open')
        }
        this.input.value = ''
    }
}

export { Search }
